import React from 'react';
import { formatCurrency } from '../../../toma-mask/fast-booking/components/functions/fucntions';
import { formatPercentage } from './helpers/cellFormatters';
import useChoice from '../../../react-hooks/useChoice';

const PriceCharge = ({ params }) => {
    const value = params?.value;
    const typeLabel = useChoice({
        type: 'priceChargeType',
        value: value?.type,
    });

    if (!value?.type) {
        return <></>;
    }

    return (
        <span>
            {typeLabel}:
            {value.percentage != null && <> {formatPercentage(value.percentage)}</>}
            {value.amount && <> {formatCurrency(value.amount)}</>}
        </span>
    );
};

export default PriceCharge;
